import React from "react";
import { ArrowRightCircle } from "lucide-react";
import "./CallToAction.css";
import { Link, useNavigate } from "react-router-dom";

const CallToAction = () => {
  return (
    <section className="call-to-action-section">
      <div className="call-to-action-content">
        <h2 className="call-to-action-title">Start Your Preparation Today</h2>
        <p className="call-to-action-subtitle">Join the best coaching and secure your future with top-notch guidance.</p>
        <a href="https://wa.me/918709364253">
          <button className="call-to-action-button">
            Book Free Counseling <ArrowRightCircle size={18} />
          </button>
        </a>
      </div>
    </section>
  );
};

export default CallToAction;